<div>
  <div [hidden]="!isLoading" style="height: calc(100vh - 75px); text-align: center; padding-top: 20vh;">
    <button class="btn btn-lg btn-dark powerbi-loading"><span class="spinner-border" role="status"></span> Preparing dashboard</button>
  </div>

  <div [hidden]="!errorReceived" style="height: calc(100vh - 75px); text-align: center; padding-top: 20px;">
    <h5><strong>An error occurred while attempting to load the dashboard.</strong></h5>
    <p>{{errorMessage}}</p>
    <p>If this problem persists, please contact the <a href="mailto:support@mi4.com?Subject=Report%20Viewer%20Issue">Mi4 Support Team.</a></p>
  </div>

  <div id="dashboardContainer" [hidden]="isLoading || errorReceived" style="height: calc(100vh - 75px);" #dashboardContainer></div>
</div>
